/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlCategory3 } from './ControlCategory3';
import {
    ControlCategory3FromJSON,
    ControlCategory3FromJSONTyped,
    ControlCategory3ToJSON,
} from './ControlCategory3';
import type { ControlContainment } from './ControlContainment';
import {
    ControlContainmentFromJSON,
    ControlContainmentFromJSONTyped,
    ControlContainmentToJSON,
} from './ControlContainment';
import type { ControlIntegrationPlatform1 } from './ControlIntegrationPlatform1';
import {
    ControlIntegrationPlatform1FromJSON,
    ControlIntegrationPlatform1FromJSONTyped,
    ControlIntegrationPlatform1ToJSON,
} from './ControlIntegrationPlatform1';
import type { ControlJSONLog } from './ControlJSONLog';
import {
    ControlJSONLogFromJSON,
    ControlJSONLogFromJSONTyped,
    ControlJSONLogToJSON,
} from './ControlJSONLog';
import type { ControlSeverity2 } from './ControlSeverity2';
import {
    ControlSeverity2FromJSON,
    ControlSeverity2FromJSONTyped,
    ControlSeverity2ToJSON,
} from './ControlSeverity2';
import type { ControlStatus3 } from './ControlStatus3';
import {
    ControlStatus3FromJSON,
    ControlStatus3FromJSONTyped,
    ControlStatus3ToJSON,
} from './ControlStatus3';
import type { ControlVerdict4 } from './ControlVerdict4';
import {
    ControlVerdict4FromJSON,
    ControlVerdict4FromJSONTyped,
    ControlVerdict4ToJSON,
} from './ControlVerdict4';
import type { ControlVerdictRule } from './ControlVerdictRule';
import {
    ControlVerdictRuleFromJSON,
    ControlVerdictRuleFromJSONTyped,
    ControlVerdictRuleToJSON,
} from './ControlVerdictRule';

/**
 * 
 * @export
 * @interface ControlDetection
 */
export interface ControlDetection {
    /**
     * 
     * @type {string}
     * @memberof ControlDetection
     */
    actionSlug?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetection
     */
    autoClosed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetection
     */
    autoContained?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlDetection
     */
    caseId?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetection
     */
    caseSid?: string;
    /**
     * 
     * @type {ControlCategory3}
     * @memberof ControlDetection
     */
    category: ControlCategory3;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetection
     */
    chatOpsTest: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlDetection
     */
    chatOpsTestEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetection
     */
    chatOpsTestPhoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetection
     */
    closedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetection
     */
    containOnChatOpsFailure: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetection
     */
    contained: boolean;
    /**
     * 
     * @type {Array<ControlContainment>}
     * @memberof ControlDetection
     */
    containments: Array<ControlContainment>;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetection
     */
    containsHVA: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetection
     */
    containsVIP: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlDetection
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetection
     */
    customDetectionId?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetection
     */
    duplicateDetectionId?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetection
     */
    escalatedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetection
     */
    excludeFromMeans: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetection
     */
    excluded: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlDetection
     */
    exclusionId?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetection
     */
    exclusionSid?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetection
     */
    externalCustomDetectionId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetection
     */
    firstRun: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlDetection
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetection
     */
    integrationId?: string;
    /**
     * 
     * @type {ControlIntegrationPlatform1}
     * @memberof ControlDetection
     */
    integrationPlatform: ControlIntegrationPlatform1;
    /**
     * 
     * @type {string}
     * @memberof ControlDetection
     */
    lastRefreshAt?: string;
    /**
     * 
     * @type {Array<ControlJSONLog>}
     * @memberof ControlDetection
     */
    logs: Array<ControlJSONLog>;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetection
     */
    managedByThirdParty: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlDetection
     */
    nextSteps?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetection
     */
    notes?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ControlDetection
     */
    ocsfDetectionFinding: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetection
     */
    prevented: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ControlDetection
     */
    raw: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ControlDetection
     */
    refreshRaw?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetection
     */
    reingested: boolean;
    /**
     * 
     * @type {ControlSeverity2}
     * @memberof ControlDetection
     */
    severity: ControlSeverity2;
    /**
     * 
     * @type {number}
     * @memberof ControlDetection
     */
    severityOrdinal: number;
    /**
     * 
     * @type {string}
     * @memberof ControlDetection
     */
    sid: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetection
     */
    sourceDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetection
     */
    sourceDetectedAt: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetection
     */
    sourceIngestedAt: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetection
     */
    sourceName?: string;
    /**
     * 
     * @type {ControlStatus3}
     * @memberof ControlDetection
     */
    status: ControlStatus3;
    /**
     * 
     * @type {string}
     * @memberof ControlDetection
     */
    teamId: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetection
     */
    teamName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetection
     */
    testMode: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlDetection
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetection
     */
    updatedAt?: string;
    /**
     * 
     * @type {ControlVerdict4}
     * @memberof ControlDetection
     */
    verdict: ControlVerdict4;
    /**
     * 
     * @type {ControlVerdictRule}
     * @memberof ControlDetection
     */
    verdictSetting?: ControlVerdictRule;
    /**
     * 
     * @type {string}
     * @memberof ControlDetection
     */
    verdictedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetection
     */
    wasEscalated: boolean;
}

/**
 * Check if a given object implements the ControlDetection interface.
 */
export function instanceOfControlDetection(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "chatOpsTest" in value;
    isInstance = isInstance && "containOnChatOpsFailure" in value;
    isInstance = isInstance && "contained" in value;
    isInstance = isInstance && "containments" in value;
    isInstance = isInstance && "containsHVA" in value;
    isInstance = isInstance && "containsVIP" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "excludeFromMeans" in value;
    isInstance = isInstance && "excluded" in value;
    isInstance = isInstance && "firstRun" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "integrationPlatform" in value;
    isInstance = isInstance && "logs" in value;
    isInstance = isInstance && "managedByThirdParty" in value;
    isInstance = isInstance && "ocsfDetectionFinding" in value;
    isInstance = isInstance && "prevented" in value;
    isInstance = isInstance && "raw" in value;
    isInstance = isInstance && "reingested" in value;
    isInstance = isInstance && "severity" in value;
    isInstance = isInstance && "severityOrdinal" in value;
    isInstance = isInstance && "sid" in value;
    isInstance = isInstance && "sourceDetectedAt" in value;
    isInstance = isInstance && "sourceIngestedAt" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "teamId" in value;
    isInstance = isInstance && "testMode" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "verdict" in value;
    isInstance = isInstance && "wasEscalated" in value;

    return isInstance;
}

export function ControlDetectionFromJSON(json: any): ControlDetection {
    return ControlDetectionFromJSONTyped(json, false);
}

export function ControlDetectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlDetection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'actionSlug': !exists(json, 'actionSlug') ? undefined : json['actionSlug'],
        'autoClosed': !exists(json, 'autoClosed') ? undefined : json['autoClosed'],
        'autoContained': !exists(json, 'autoContained') ? undefined : json['autoContained'],
        'caseId': !exists(json, 'caseId') ? undefined : json['caseId'],
        'caseSid': !exists(json, 'caseSid') ? undefined : json['caseSid'],
        'category': ControlCategory3FromJSON(json['category']),
        'chatOpsTest': json['chatOpsTest'],
        'chatOpsTestEmail': !exists(json, 'chatOpsTestEmail') ? undefined : json['chatOpsTestEmail'],
        'chatOpsTestPhoneNumber': !exists(json, 'chatOpsTestPhoneNumber') ? undefined : json['chatOpsTestPhoneNumber'],
        'closedAt': !exists(json, 'closedAt') ? undefined : json['closedAt'],
        'containOnChatOpsFailure': json['containOnChatOpsFailure'],
        'contained': json['contained'],
        'containments': ((json['containments'] as Array<any>).map(ControlContainmentFromJSON)),
        'containsHVA': json['containsHVA'],
        'containsVIP': json['containsVIP'],
        'createdAt': json['createdAt'],
        'customDetectionId': !exists(json, 'customDetectionId') ? undefined : json['customDetectionId'],
        'duplicateDetectionId': !exists(json, 'duplicateDetectionId') ? undefined : json['duplicateDetectionId'],
        'escalatedAt': !exists(json, 'escalatedAt') ? undefined : json['escalatedAt'],
        'excludeFromMeans': json['excludeFromMeans'],
        'excluded': json['excluded'],
        'exclusionId': !exists(json, 'exclusionId') ? undefined : json['exclusionId'],
        'exclusionSid': !exists(json, 'exclusionSid') ? undefined : json['exclusionSid'],
        'externalCustomDetectionId': !exists(json, 'externalCustomDetectionId') ? undefined : json['externalCustomDetectionId'],
        'firstRun': json['firstRun'],
        'id': json['id'],
        'integrationId': !exists(json, 'integrationId') ? undefined : json['integrationId'],
        'integrationPlatform': ControlIntegrationPlatform1FromJSON(json['integrationPlatform']),
        'lastRefreshAt': !exists(json, 'lastRefreshAt') ? undefined : json['lastRefreshAt'],
        'logs': ((json['logs'] as Array<any>).map(ControlJSONLogFromJSON)),
        'managedByThirdParty': json['managedByThirdParty'],
        'nextSteps': !exists(json, 'nextSteps') ? undefined : json['nextSteps'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'ocsfDetectionFinding': json['ocsfDetectionFinding'],
        'prevented': json['prevented'],
        'raw': json['raw'],
        'refreshRaw': !exists(json, 'refreshRaw') ? undefined : json['refreshRaw'],
        'reingested': json['reingested'],
        'severity': ControlSeverity2FromJSON(json['severity']),
        'severityOrdinal': json['severityOrdinal'],
        'sid': json['sid'],
        'sourceDescription': !exists(json, 'sourceDescription') ? undefined : json['sourceDescription'],
        'sourceDetectedAt': json['sourceDetectedAt'],
        'sourceIngestedAt': json['sourceIngestedAt'],
        'sourceName': !exists(json, 'sourceName') ? undefined : json['sourceName'],
        'status': ControlStatus3FromJSON(json['status']),
        'teamId': json['teamId'],
        'teamName': !exists(json, 'teamName') ? undefined : json['teamName'],
        'testMode': json['testMode'],
        'title': json['title'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'verdict': ControlVerdict4FromJSON(json['verdict']),
        'verdictSetting': !exists(json, 'verdictSetting') ? undefined : ControlVerdictRuleFromJSON(json['verdictSetting']),
        'verdictedAt': !exists(json, 'verdictedAt') ? undefined : json['verdictedAt'],
        'wasEscalated': json['wasEscalated'],
    };
}

export function ControlDetectionToJSON(value?: ControlDetection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'actionSlug': value.actionSlug,
        'autoClosed': value.autoClosed,
        'autoContained': value.autoContained,
        'caseId': value.caseId,
        'caseSid': value.caseSid,
        'category': ControlCategory3ToJSON(value.category),
        'chatOpsTest': value.chatOpsTest,
        'chatOpsTestEmail': value.chatOpsTestEmail,
        'chatOpsTestPhoneNumber': value.chatOpsTestPhoneNumber,
        'closedAt': value.closedAt,
        'containOnChatOpsFailure': value.containOnChatOpsFailure,
        'contained': value.contained,
        'containments': ((value.containments as Array<any>).map(ControlContainmentToJSON)),
        'containsHVA': value.containsHVA,
        'containsVIP': value.containsVIP,
        'createdAt': value.createdAt,
        'customDetectionId': value.customDetectionId,
        'duplicateDetectionId': value.duplicateDetectionId,
        'escalatedAt': value.escalatedAt,
        'excludeFromMeans': value.excludeFromMeans,
        'excluded': value.excluded,
        'exclusionId': value.exclusionId,
        'exclusionSid': value.exclusionSid,
        'externalCustomDetectionId': value.externalCustomDetectionId,
        'firstRun': value.firstRun,
        'id': value.id,
        'integrationId': value.integrationId,
        'integrationPlatform': ControlIntegrationPlatform1ToJSON(value.integrationPlatform),
        'lastRefreshAt': value.lastRefreshAt,
        'logs': ((value.logs as Array<any>).map(ControlJSONLogToJSON)),
        'managedByThirdParty': value.managedByThirdParty,
        'nextSteps': value.nextSteps,
        'notes': value.notes,
        'ocsfDetectionFinding': value.ocsfDetectionFinding,
        'prevented': value.prevented,
        'raw': value.raw,
        'refreshRaw': value.refreshRaw,
        'reingested': value.reingested,
        'severity': ControlSeverity2ToJSON(value.severity),
        'severityOrdinal': value.severityOrdinal,
        'sid': value.sid,
        'sourceDescription': value.sourceDescription,
        'sourceDetectedAt': value.sourceDetectedAt,
        'sourceIngestedAt': value.sourceIngestedAt,
        'sourceName': value.sourceName,
        'status': ControlStatus3ToJSON(value.status),
        'teamId': value.teamId,
        'teamName': value.teamName,
        'testMode': value.testMode,
        'title': value.title,
        'updatedAt': value.updatedAt,
        'verdict': ControlVerdict4ToJSON(value.verdict),
        'verdictSetting': ControlVerdictRuleToJSON(value.verdictSetting),
        'verdictedAt': value.verdictedAt,
        'wasEscalated': value.wasEscalated,
    };
}

